// react, react-redux, redux-form, axios
import React from "react";
import { connect } from "react-redux";
import { Field, FormSection } from "redux-form";
import axios from 'axios';

// helpers
import { htmlEncodeIds } from "../../../helpers/renderHelpers";
import { required } from "../../../helpers/validate";

// Redux actions
import { updateAddress, checkMapshareData } from "../../../actions/formActions";

// enums
import { STATE_LIST } from "../../../config/enums";

// render components
import RenderField from "../RenderField";
import Autosuggest from 'react-autosuggest';

// styling
import "./AddressSuggestion.scss";

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.text;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => ( <
    div > { suggestion.text } <
    /div>
);

const renderSectionTitle = section => ( <
    p > { section.title } < /p>
)

const getSectionSuggestions = section => {
    return section.properties;
}


class AddressSuggestion extends React.Component {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {
            value: '',
            suggestions: [],
            isManual: false,
            required: false
        };
    }

    componentDidMount() {
        if (this.props.addresses.findIndex(address => address.id === this.myRef.current.input.id) === -1) {
            this.props.updateAddress(
                this.myRef.current.input.id,
                '',
                false,
                false,
                true
            )
        }

        this.props.checkMapshareData(this.myRef.current.input.id, this.state.isManual)

        const id = htmlEncodeIds(JSON.stringify(this.props.fields));
        this.setState({
            value: (this.props.addresses.findIndex(address => address.id === id) > -1) ? this.props.addresses.find(address => address.id === id).value : this.state.value
        });
        this.setState({
            isManual: (this.props.addresses.findIndex(address => address.id === id) > -1) ? this.props.addresses.find(address => address.id === id).isManual : this.state.isManual
        });
        this.setState({
            required: this.props.required
        });
    }

    onChange = (event, { newValue }) => {
        this.props.updateAddress(
            this.myRef.current.input.id,
            newValue,
            false,
            false,
            this.myRef.current.input.required);

        this.setState({
            value: newValue,
            selectedStatus: 'new'
        });
    };

    loadSuggestions(value) {
        const element = this;
        const instance = axios.create();
        const options = {
            method: 'GET',
            params: {
                text: value
            },
            url: 'https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMAddressEZIAdd/GeocodeServer/suggest?category=&location=&distance=&f=pjson'
        }

        instance(options)
            .then(function(response) {

                if (response.data.suggestions) {
                    element.setState({
                        suggestions: [{
                            title: 'Select an address',
                            properties: response.data.suggestions
                        }]
                    });
                } else {
                    var error = response.data;
                    throw error;
                }
            })
            .catch(function(error) {
                console.log(error)
            });
    }

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestions(value);
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };


    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        const element = this;
        const firstInstance = axios.create();
        const firstOptions = {
            method: 'GET',
            params: {
                magicKey: suggestion.magicKey
            },
            url: 'https://corp-geo.mapshare.vic.gov.au/arcgis/rest/services/Geocoder/VMAddressEZIAdd/GeocodeServer/findAddressCandidates?SingleKey=&Single+Line+Input=&category=&outFields=*&maxLocations=1&outSR=&searchExtent=&location=&distance=&f=pjson',
            selectedStatus: 'selected'
        }

        firstInstance(firstOptions)
            .then(function(response) {

                const secondInstance = axios.create();
                const secondOptions = {
                    method: 'GET',
                    params: {
                        where: "PROPERTY_PFI='" + response.data.candidates[0].attributes.User_fld + "'"
                    },
                    url: 'https://corp-gis.mapshare.vic.gov.au/arcgis/rest/services/Mapshare/PropertyAndParcel/MapServer/3/query?outFields=*&returnGeometry=true&returnZ=false&returnM=false&f=json&outSR=4283'
                }

                secondInstance(secondOptions)
                    .then(function(response) {

                        const form = element.props.form;
                        const fields = element.props.fields;
                        const attributes = response.data.features[0].attributes;

                        element.props.updateAddress(
                            element.myRef.current.input.id,
                            suggestionValue,
                            true,
                            false,
                            false)

                        // unitNo          
                        form.props.change(fields.unitNo, (attributes.BLG_UNIT_ID_2) ? attributes.BLG_UNIT_ID_1 + "-" + attributes.BLG_UNIT_ID_2 : attributes.BLG_UNIT_ID_1);
                        // streetNo
                        form.props.change(fields.streetNo, (attributes.HOUSE_NUMBER_2) ? attributes.HOUSE_NUMBER_1 + "-" + attributes.HOUSE_NUMBER_2 : attributes.HOUSE_NUMBER_1);
                        // streetName
                        form.props.change(fields.streetName, attributes.ROAD_NAME + ' ' + attributes.ROAD_TYPE)
                            // suburb
                        form.props.change(fields.suburb, attributes.LOCALITY_NAME)
                            // state
                        form.props.change(fields.state, attributes.STATE)
                            // state
                        form.props.change(fields.postcode, attributes.POSTCODE)
                            // country
                        form.props.change(fields.country, "Australia")

                    })

                .catch(function(error) {
                    console.log(error)
                });



                //return axios.get(...); // using response.data
            })
            .catch(function(error) {
                console.log(error)
            });
    }

    render() {
        const { value, suggestions } = this.state;
        const id = htmlEncodeIds(JSON.stringify(this.props.fields));
        const isManual = this.props.mapShareData === false || (this.props.addresses.find(address => address.id === id && address.isManual === true)) ? true : false;

        const isRequired = this.props.addresses.find(address => (address.id === id && address.isSelected === false && address.isManual === false)) ? true : false;

        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            placeholder: 'Type to find an address',
            value: (this.props.addresses.findIndex(address => address.id === id) > -1) ? this.props.addresses.find(address => address.id === id).value : value,
            onChange: this.onChange,
            autoComplete: 'address-suggestion',
            id: id,
            required: isRequired
        };

        return (

                <
                FormSection className = "sq-form-section"
                name = "address" >
                <
                div className = "sq-form-section-description" >
                <
                h4 > Address < /h4> < /
                div > <
                div className = { `sq-form-question sq-form-question-text sq-form-question--focus${isManual ? " hidden" : ""}` } >
                <
                label className = "sq-form-question-title sq-form-question-title-requiredAsterisk"
                htmlFor = { id } >
                Select an address <
                /label>    <
                div className = "sq-form-question-answer " >
                <
                Autosuggest ref = { this.myRef }
                multiSection = { true }
                suggestions = { suggestions }
                onSuggestionsFetchRequested = { this.onSuggestionsFetchRequested }
                getSuggestionValue = { getSuggestionValue }
                onSuggestionSelected = { this.onSuggestionSelected }
                onSuggestionsClearRequested = { this.onSuggestionsClearRequested }
                renderSuggestion = { renderSuggestion }
                renderSectionTitle = { renderSectionTitle }
                getSectionSuggestions = { getSectionSuggestions }
                inputProps = { inputProps }
                /> {
                isRequired && ( <
                    p className = "sq-form-error" > Please select an address < /p>
                )
            } <
            /div> < /
        div > <
            div className = { this.props.mapShareData === false ? 'hidden' : '' } >
            <
            Field name = { id + "-manual" }
        type = "checkbox"
        onChange = {
            () => {
                this.setState({ isManual: isManual === true ? false : true })
                this.setState({ required: isRequired })
                this.props.updateAddress(
                    this.myRef.current.input.id,
                    '',
                    false,
                    isManual === true ? false : true,
                    isRequired)
            }
        }
        component = { RenderField }
        templateList = {
            [{ name: "Can't find your address?", value: "true" }]
        }
        /> < /
        div > <
            div className = { `sq-form-section${isManual ? "" : " hidden"}` } >
            <
            Field name = "unitNo"
        type = "text"
        component = { RenderField }
        label = "Unit No."
        width = "fifth" /
            >
            <
            Field name = "streetNo"
        type = "text"
        component = { RenderField }
        label = "Street No."
        width = "fifth"
        validate = { isManual ? required : null }
        required = { isManual }
        /> <
        Field name = "streetName"
        type = "text"
        component = { RenderField }
        label = "Street Name"
        width = "half"
        validate = { isManual ? required : null }
        required = { isManual }
        /> <
        Field name = "suburb"
        type = "text"
        component = { RenderField }
        label = "Suburb"
        width = "fourth"
        validate = { isManual ? required : null }
        required = { isManual }
        /> <
        Field name = "state"
        type = "select"
        component = { RenderField }
        templateList = { STATE_LIST }
        label = "State"
        width = "fifth"
        validate = { isManual ? required : null }
        required = { isManual }
        /> <
        Field name = "postcode"
        type = "text"
        component = { RenderField }
        maxlength = "4"
        label = "Postcode"
        width = "fifth"
        validate = { isManual ? required : null }
        required = { isManual }
        /> <
        Field name = "country"
        type = "text"
        component = { RenderField }
        label = "Country"
        width = "half"
        validate = { isManual ? required : null }
        required = { isManual }
        /> < /
        div > <
            /FormSection>


    )
}
}

const mapStateToProps = state => {
    return {
        addresses: state.service.addresses,
        mapShareData: state.service.mapShareData
    };
};

const mapDispatchToProps = {
    updateAddress,
    checkMapshareData
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddressSuggestion);